module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil') ? _c('div', {
    staticClass: "portlet box green"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('label', [_vm._v("Quantos banhos o aluno tomou hoje?")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "99",
      "placeholder": "Exemplo: 1"
    },
    domProps: {
      "value": _vm.bathsQuantity
    },
    on: {
      "change": _vm.putAgendaBathQuantity
    }
  })])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-bath",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\tBanhos\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a964a64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/health/bath-quantity/StudentBathQuantity.vue
// module id = 1090
// module chunks = 1